export const skills = [
    {
        name: 'PhysicalEd',
        title: 'Physical Ed',
    },
    {
        name: 'Science',
        title: 'Science',
    },
    {
        name: 'InformationTech',
        title: 'Information Tech',
    },
    {
        name: 'Music',
        title: 'Music',
    },
    {
        name: 'ReligiousStudies',
        title: 'Religious Studies',
    },
    {
        name: 'Literature',
        title: 'Literature',
    },
    {
        name: 'Legal',
        title: 'Legal',
    },
    {
        name: 'WoodWork',
        title: 'Wood Work',
    },
    {
        name: 'MetalWork',
        title: 'Metal Work',
    },
    {
        name: 'Mandarin',
        title: 'Mandarin',
    },
    {
        name: 'French',
        title: 'French',
    },
    {
        name: 'Italian',
        title: 'Italian',
    },
    {
        name: 'Indonesian',
        title: 'Indonesian',
    },
    {
        name: 'German',
        title: 'German',
    },
    {
        name: 'Japanese',
        title: 'Japanese',
    },
    {
        name: 'Maths',
        title: 'Maths',
    },
    {
        name: 'English',
        title: 'English',
    },
    {
        name: 'Health',
        title: 'Health',
    },
    {
        name: 'Accounting',
        title: 'Accounting',
    },
    {
        name: 'Politics',
        title: 'Politics',
    },
    {
        name: 'Physics',
        title: 'Physics',
    },
    {
        name: 'Art',
        title: 'Art',
    },
    {
        name: 'Psychology',
        title: 'Psychology',
    },
    {
        name: 'History',
        title: 'History',
    },
];
